module.exports = __webpack_public_path__ + "static/partners-fd919fbeb4672e5d3c02be952c1f299f.svg";